module.exports = __webpack_public_path__ + "static/media/profile.6ffd1038.jpg";